import { render } from "./editor_layout.vue?vue&type=template&id=1c1d9b82&scoped=true"
import script from "./editor_layout.vue?vue&type=script&lang=js"
export * from "./editor_layout.vue?vue&type=script&lang=js"

import "./editor_layout.vue?vue&type=style&index=0&id=1c1d9b82&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1d9b82"]])

export default __exports__